// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1I07j","info":"PatientInfo_info__3Pj51"};